
<template>
  <div style="height: 100%">
    <card-loading-transparent v-if="!chart_ready || loading_dash"></card-loading-transparent>


    <bar-chart v-if="chart_ready && !loading_dash" style=" height: 100%; width:100%" :chart-data="chart_data" :options="chart_options"></bar-chart>


  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'LostAndPendingChart',
  components: {
    BarChart: () => import('@/components/charts/BarChart.vue'),
  },
  props: {
    loading_dash:{
      type: Boolean,
      default: true,
    },
    report_data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      chart_ready: false,

      report: {},

      chart_data: {
        datasets: [
          {
            data: [],
            backgroundColor: '#e33e43', 
            borderColor: [],
            borderWidth: 2,
            hoverBackgroundColor: [],
            label: 'Descontados',
            helper: 'discount'
          },
          {
            data: [],
            backgroundColor: '#ffbf00', 
            borderColor: [],
            borderWidth: 2,
            hoverBackgroundColor: [],
            label: 'Pendentes',
            helper: 'pending'
          },
        ],
        labels: [], // serão os meses
      },
      chart_options: {
        height: '10px', 
        width: '500px', 
        responsive: true,
        maintainAspectRatio: false,
        plugins:{
          datalabels: {
            align: 'center',
            anchor: 'bottom',
            // rotation: 90,
            color: function(ctx) {
              var is_sell = ctx.chart.data.labels[ctx.dataIndex].includes('Ab')
              return is_sell ? 'black' : 'black'
            },
            font: {
              weight: 'bold',
              size: window.innerWidth < 1000? 15 : 22
            },
          }
        },
        events: ['click', 'mousemove'],
        // onClick: (e)=> {
        //   this.handleClick(e)
        // },
        // cornerRadius: 15,
        scales: {
          yAxes: [{
            display: true,
            stacked: false,
            ticks: {
              fontSize: 14
            }
          }],
          xAxes: [{
            stacked: false,
            ticks: {
              fontSize: 15
            }
            // barPercentage: 0.5,
            // categoryPercentage: 1.0
          }],
        },
        legend:{
          display: true
        },
        tooltips: {
          enabled: true,
          mode: 'index',
          callbacks: {
            label: function(tooltipItems, data) { 
              //    // auto-comment// console.log({tooltipItems});
              //    // auto-comment// console.log({data});
              // data.datasets[tooltipItems.datasetIndex].label
              return  data.datasets[tooltipItems.datasetIndex].label+ ': ' + tooltipItems.yLabel;
            },
          }
        },
      },
    }
  },
  methods: {
    getData(){
      this.report = this.report_data || {
        months: [ 'Jan/21', 'Fev/21', 'Mar/21', 'Abr/21', 'Mai/21', 'Jun/21', ],
        data_1: [
          {
            kind: 'discount',
            monthly_count: [100,200,300,400,500,600]
          },
          {
            kind: 'pending',
            monthly_count: [10,20,30,40,50,60]
          },
        ],
        data_2: {
          discount: [100, 200, 300, 400, 500, 600],
          pending: [10,20,30,40,50,60],
        }
      }
    },


    loadChart() {
      this.chart_ready = false

      this.chart_data.labels = [...this.report.months.map(d=>d.toUpperCase())]

      let map = this.chart_data.datasets.map( ({helper}) => helper) // ['discount', 'pending']
      map.forEach( (k, k_idx) => {
        this.chart_data.datasets[k_idx].data = [...this.report.data[k]].map(d=> Math.round(d))
      })

      // for (let idx = 0; idx < this.report.data.length; idx++) {
      //   const {kind, monthly_count} = this.report.data[idx];
      //   const ds_idx = this.chart_data.datasets.findIndex( ({helper}) => helper == kind)
      //   this.chart_data.datasets[ds_idx].data = [...monthly_count]
      // }
      
      
      setTimeout(() => {
        this.chart_ready = true
      }, 500);
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    this.getData();
    this.loadChart()
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    report_data(nv,ov) {
      if (nv){
        this.getData();
        this.loadChart()
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>